export const INCREASE_PDP_HISTORY = 'increasePdpHistory';
export const DECREASE_PDP_HISTORY = 'decreasePdpHistory';
export const RESET_PDP_HISTORY = 'resetPdpHistory';
export const INCREASE_BACK_BUTTON_HISTORY = 'increaseBackButtonHistory';
export const RESET_BACK_BUTTON_HISTORY = 'resetBackButtonHistory';
